module.exports = __webpack_public_path__ + "opel.d1a44d8fc18d09843809.png";